// @flow
import * as React from 'react';
import styled from 'styled-components';
import {Fade} from './Animation';
import {LayoutCenterMiddle} from './Layout';
import {LocalizedParagraph, Paragraph, type LocalizedText} from './Localized';

type Props = {
  show: boolean,
  localText?: LocalizedText,
  textKey?: string,
  children?: React.Node,
  autoHide?: number,
  handleAutoHide?: () => void
};

export default function GuideMessageCenter(props: Props): React.Element<any> {
  const [hide, setHide] = React.useState(false);
  const {show, localText, textKey, children, autoHide, handleAutoHide, ...others} = props;
  const timer = React.useRef(null);
  

  React.useEffect(() => {
    if (autoHide && show === true) {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
      timer.current = setTimeout(() => {
        setHide(true);
        if (handleAutoHide != null) {
          handleAutoHide();
        }
        
      }, autoHide);
    }
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    }
  }, [show, autoHide, handleAutoHide]);

  return (
    <Fade appear={true} enter={false} in={show && !hide} timeout={500} >
      <GuideMessageWrapper {...others}>
        {localText && <LocalizedParagraph {...localText} />}
        {textKey && <Paragraph textKey={textKey} />}
        {children}
      </GuideMessageWrapper>
    </Fade>
  );
}


export function GuideMessageInline(props: Props): React.Element<any> {
  const {show, localText, textKey, children, ...others} = props;
  return (
    <Fade appear={true} enter={false} in={show} timeout={500}>
      <GuideMessageWrapper2 {...others}>
        {localText && <LocalizedParagraph {...localText} />}
        {textKey && <Paragraph textKey={textKey} />}
        {children}
      </GuideMessageWrapper2>
    </Fade>
  );
}


const GuideMessageWrapper = styled(LayoutCenterMiddle)`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const GuideMessageWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;